<template>
    <div class="panel panel-default form-horizontal">
        <div class="panel-heading">
            <h5 class="pull-left">
                Subscription Period
            </h5>

            <button
                    type="button"
                    class="btn btn-xs btn-black pull-right"
                    @click="$emit('remove')"
                    style="margin-top: 8px"
            >
                <i class="fa fa-minus"></i> Remove
            </button>

            <div class="clearfix"></div>
        </div>

        <div class="panel-body">
            <number-form-group
                    :value="subscriptionPeriod.price"
                    name="price"
                    label="Price"
                    help-text="The price of the subscription period."
                    :error="getError('price')"
                    @input="update('price', $event)"
            ></number-form-group>

            <date-form-group
                    :value="subscriptionPeriod.starts_at"
                    name="starts_at"
                    label="Starts At"
                    help-text="The date that the subscription period starts."
                    :error="getError('starts_at')"
                    @input="update('starts_at', $event)"
                    format="DD.MM.YYYY"
            ></date-form-group>

            <date-form-group
                    :value="subscriptionPeriod.ends_at"
                    name="ends_at"
                    label="Ends At"
                    help-text="The date that the subscription period ends."
                    :error="getError('ends_at')"
                    :disabled="missingPermission('admin')"
                    @input="update('ends_at', $event)"
                    format="DD.MM.YYYY"
            ></date-form-group>

            <date-form-group
                    :value="subscriptionPeriod.closes_at"
                    name="closes_at"
                    label="Closes At"
                    help-text="The date that the subscription period will be closed if the invoice is not paid."
                    :error="getError('closes_at')"
                    @input="update('closes_at', $event)"
                    format="DD.MM.YYYY"
            ></date-form-group>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import DateFormGroup from '@/vendor/forms/FormGroups/Horizontal/Date'
    import NumberFormGroup from '@/vendor/forms/FormGroups/Horizontal/Number'
    import Permissions from '@/mixins/Permissions'

    export default {
        components: {DateFormGroup, NumberFormGroup},

        mixins: [Permissions],

        props: ['subscriptionPeriod', 'subscription', 'index', 'errors'],

        watch: {
            'subscriptionPeriod.starts_at'(value) {
                this.$emit('input', {
                    ...this.subscriptionPeriod,
                    ends_at: moment(value).add(this.subscription.period, 'months').format('YYYY-MM-DD'),
                    closes_at: moment(value).add(this.subscription.closes_after, 'days').format('YYYY-MM-DD')
                })
            }
        },

        methods: {
            update(key, value) {
                this.$emit('input', {...this.subscriptionPeriod, [key]: value})
            },

            getError(name) {
                let fullName = 'subscription_periods.' + this.index + '.' + name

                return typeof this.errors[fullName] !== 'undefined' ? this.errors[fullName][0] : null
            }
        }
    }
</script>

